import debug from 'debug'

export default debug('sanity:backup')
